var e = {
  fetch_format: "f",
  crop: "c",
  effect: "e",
  flags: "fl",
  gravity: "g",
  height: "h",
  radius: "r",
  quality: "q",
  width: "w",
  dpr: "dpr"
};

module.exports = function (o, r) {
  if (void 0 === r && (r = {}), !r.cloud_name) throw Error("options.cloud_name required");
  var t = r.secure ? "https" : "http",
      i = r.source || "upload",
      n = Object.keys(r).map(function (o) {
    var t = e[o];
    if (t) return t + "_" + r[o];
  }).filter(Boolean).join(","),
      a = r.version && "v" + r.version;
  return [t + "://res.cloudinary.com", encodeURIComponent(r.cloud_name), "image", i, n, a, o].filter(Boolean).join("/");
};